export const images = [
	'img/image1.jpg',
	'img/image2.jpg',
	'img/image3.jpg',
	'img/image4.jpg',
	'img/image5.jpg',
	'img/image6.jpg',
	'img/image7.jpg',
	'img/image8.jpg',
	'img/image9.png'
]
//��������ʹ��Vue�����룬�ؼ�
